import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getMore = (state: ContentPluginRootState) => state.data.results?.more;

export default getMore;
